module.exports = __webpack_public_path__ + "img/u12.519f28f0.png";